$("document").ready(function(){
	var class_id = $.getMeta('name','class:id');
	getUserBoardContentList('guestbook',class_id, ".box-list");
	
	$("#btn-set-guestbook").click(function(){	
		var guestbookContent = $("#guestbook-content").val();
		var guestbookState = $("#guestbook-state").val();
		
		var transData = {
			'class_id' : class_id,
			'type': 'guestbook',
			'content' : guestbookContent,
			'state' : guestbookState
		}
		
		setBoardContent(transData, ".box-list");
	});
	
});